'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../constants');

var _PropertyCell = require('../../components/PropertyCell/PropertyCell.scss');var projectStyle = _interopRequireWildcard(_PropertyCell);
var _OMBasePropertyCell = require('../../components/OMComponents/OMPropertyCells/OMBasePropertyCell/OMBasePropertyCell.scss');var mobileProjectCellStyle = _interopRequireWildcard(_OMBasePropertyCell);
var _OMBaseVerticalPropertyCell = require('../../components/OMComponents/OMPropertyCells/OMBaseVerticalPropertyCell/OMBaseVerticalPropertyCell.scss');var desktopProjectCellStyle = _interopRequireWildcard(_OMBaseVerticalPropertyCell);
var _CellPhotoBlock = require('../../components/OMComponents/OMPropertyCells/components/CellPhotoBlock/CellPhotoBlock.scss');var imageStyle = _interopRequireWildcard(_CellPhotoBlock);
var _images_placeholder = require('../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Helpers

var ProjectCellForSale = function ProjectCellForSale(props) {
  var formatPrice = function formatPrice() {var
    isMobile = props.isMobile,price = props.price,exactPrice = props.exactPrice,translate = props.translate;
    var separator = isMobile ? ' ' : ' - ';
    var nis = String.fromCharCode(8362);
    var ltrSymbol = String.fromCharCode(8206);

    var formattedPrice = exactPrice ? '' +
    ltrSymbol + nis + ' ' + (0, _beautifyNumber2.default)(exactPrice) : '' +
    translate('from') + separator + nis + (0, _beautifyNumber2.default)(price);

    return formattedPrice;
  };

  var projectCellStyle = desktopProjectCellStyle;
  return (props.location === 'homes' || props.location === 'commercial') &&
  _react2.default.createElement('div', { className: projectStyle.projectCell, onMouseEnter: props.onHover, onClick: props.openDetails },
    _react2.default.createElement('div', { className: projectCellStyle.propertyRow },
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { className: (0, _classnames2.default)(imageStyle.propertyCellPhotoBlock, imageStyle.largePhoto) },
          _react2.default.createElement('img', {
            alt: '',
            property: 'photo',
            srcSet: '\n                ' + (
            (0, _modifyImageLink2.default)(props.image, _constants.imageModifierTypes.GALLERY_THUMBNAIL) || _images_placeholder2.default) + ' 350w,\n                ' + (
            (0, _modifyImageLink2.default)(props.image, _constants.imageModifierTypes.GALLERY_THUMBNAIL_MOBILE) || _images_placeholder2.default) + ' 600w\n              ',

            sizes: '(max-width: 767px) 600px, (min-width: 768px) 350px',
            src: (0, _modifyImageLink2.default)(props.image, _constants.imageModifierTypes.GALLERY_THUMBNAIL) || _images_placeholder2.default }),

          _react2.default.createElement('div', { className: imageStyle.propertyPrice }, formatPrice()))),


      _react2.default.createElement('div', { className: (0, _classnames2.default)(projectCellStyle.propertyDescription, projectCellStyle.projectDescription) },
        _react2.default.createElement('div', { className: projectCellStyle.infoBlock },
          _react2.default.createElement('div', { className: projectCellStyle.propertyAddress },
            _react2.default.createElement('div', { className: (0, _classnames2.default)(projectCellStyle.addressWrap, projectCellStyle.addressProjectWrap) },
              _react2.default.createElement('div', null,
                _react2.default.createElement('div', { className: projectCellStyle.propertyType }, props.translate('header', 'projects')),
                _react2.default.createElement('div', { className: projectCellStyle.infoProjectWrapper },
                  _react2.default.createElement('div', { property: 'address', className: projectCellStyle.propertyAddress },
                    _react2.default.createElement('div', { className: projectCellStyle.projectName }, props.name),
                    _react2.default.createElement('div', { className: projectCellStyle.projectAddress },
                      props.address.street_name, '\xA0', props.address.house_number, ', ', props.address.city_name.replace(/ /g, '\xA0'))),


                  _react2.default.createElement('div', { className: projectCellStyle.logoProjectWrapper },
                    _react2.default.createElement('img', { alt: '', src: (0, _modifyImageLink2.default)(props.logo, _constants.imageModifierTypes.PROPERTY_THUMBNAIL) })))),



              _react2.default.createElement('div', { className: props.isMobile && projectCellStyle.propertyAddress }, _react2.default.createElement('b', null, props.translate('status'), ':\xA0'), props.status)))))));






}; // Styles


ProjectCellForSale.propTypes = {
  isMobile: _propTypes2.default.bool,
  image: _propTypes2.default.string,
  price: _propTypes2.default.number,
  exactPrice: _propTypes2.default.number,
  name: _propTypes2.default.string,
  summary: _propTypes2.default.string,
  logo: _propTypes2.default.string,
  address: _propTypes2.default.object,
  status: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  onHover: _propTypes2.default.func,
  location: _propTypes2.default.string,
  openDetails: _propTypes2.default.func };exports.default =


ProjectCellForSale;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCellForSale/ProjectCellForSale.js
// module id = 2788
// module chunks = 0